import {t} from 'i18next';
import {FILE_TYPE} from "../../../../../Helpers/fileType";
export const DEFAULT_VISITOR_TYPE = "EMPLOYEE";

const { TextFieldChip,
    NumericFieldChip,
    FileUploadChip,
    DatePickerChip,
    TimePickerChip,
    DateTimePickerChip,
    CheckboxChip} = require("../../../../../components/buttons/IconButtons");


export const FIELD_TYPES_MODEL = () => {
    return [
        { id: "TEXT", name: t("text_field"), icon: TextFieldChip },
        { id: "NUMERIC", name: t("numeric_field"), icon: NumericFieldChip },
        { id: "DOCUMENT", name: t("file_upload"), icon: FileUploadChip },
        { id: "DATE", name: t("date_picker"), icon: DatePickerChip },
        { id: "TIME", name: t("time_picker"), icon: TimePickerChip },
        { id: "DATE_TIME", name: t("date_time_picker"), icon: DateTimePickerChip },
        { id: "CHECKBOX", name: t("checkbox"), icon: CheckboxChip },
    ];
}

export const FIELD_TYPE ={
    TEXT : {name:'TEXT',length:500, position:1 },
    NUMERIC : {name:'NUMERIC',length:64, position:2 },
    DATE : {name:'DATE', length: 0, position:3 },
    TIME :{name:'TIME', length: 0, position:4 },
    DATE_TIME :{name:'DATE_TIME', length:0, position:5 },
    CHECKBOX :{name:'CHECKBOX', length: 0, position:6 },
    DOCUMENT : {name:'DOCUMENT', length: FILE_TYPE.IMAGE_FILES_VIDEOS.size,  position:7 },
}

export function sortListFieldType(fields) {
    if (!Array.isArray(fields) || fields.length === 0) {
        return [];
    }
    return [...fields].sort((a, b) => {
        const posA = FIELD_TYPE[a.fieldType]?.position ?? 999;
        const posB = FIELD_TYPE[b.fieldType]?.position ?? 999;
        return posA - posB;
    });
}

export const VISITOR_TYPE_MODEL = {
    id: null,
    name: '',
    fields:[],
    isValid: function () {
        return this.name?.trim() !== '';
    },
    isValidFields: function (fields) {
        return fields?.length > 0;
    },
    toRegister: function (fields) {
        return {
            id: this.id,
            name: this.name,
            fields: fields.map(e => {
                if(typeof e.id === 'string') return e;
                else return {...e, id:null};
            }),
        }
    },
    set: function (data) {
        return {
            ...this,
            id: data.id,
            name: data.name,
            fields: []
        }
    },
}

export const CUSTOM_FIELD_MODEL = {
    id: null,
    fieldName: '',
    fieldType: null,
    isRequired: false,
    isValid: function (){
        return this.fieldName?.trim() !== '' && this.fieldType?.trim() !== '' && this.fieldType != null
    }
};

export const getFieldTypeById = (id) => {
    const row = FIELD_TYPES_MODEL().find(e => e.id === id);
    return row || null;
};

export const getIndexFieldByAllData = (list, field) => {
    return list.findIndex(e => e.id === field.id && e.fieldName === field.fieldName && e.fieldType === field.fieldType && e.isRequired === field.isRequired);
};
